import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import fetchCSRFToken from "../utils/fetchCSRFToken";
import { TextField, Button, Typography, CircularProgress } from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";

const ResetPasswordPage = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCSRFToken();
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("❌ Passwords do not match");
      setMessage("");
      return;
    }

    setLoading(true);
    try {
      await api.post(
        `users/reset/${uid}/${token}/`,
        {
          new_password1: password,
          new_password2: confirm,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      setMessage("✅ Password reset successful! Redirecting...");
      setError("");
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError("❌ Invalid or expired reset link");
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 space-y-6 text-center">
        <Typography variant="h5" className="font-semibold text-gray-800">
          Reset Password
        </Typography>

        {message && (
          <Typography className="text-green-600 text-sm">{message}</Typography>
        )}
        {error && (
          <Typography className="text-red-600 text-sm">{error}</Typography>
        )}

        <form onSubmit={handleReset} className="space-y-4">
          <TextField
            label="New Password"
            type="password"
            fullWidth
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <TextField
            label="Confirm New Password"
            type="password"
            fullWidth
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            className="bg-blue-600 hover:bg-blue-700 text-white"
            disabled={loading}
            startIcon={<LockResetIcon />}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Reset Password"
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
